import type { ReactNode } from "react";
import DashboardIcon from "@mui/icons-material/Dashboard";
import EventNoteIcon from "@mui/icons-material/EventNote";
import GppMaybeIcon from "@mui/icons-material/GppMaybe";
import NotificationsActiveIcon from "@mui/icons-material/NotificationsActive";
import VerifiedUserIcon from "@mui/icons-material/VerifiedUser";
import type { FeatureFlags } from "@/hooks/useFeatureFlags.tsx";
import CountedNavIcon from "./CountedNavIcon.tsx";

interface NavDefinition {
  readonly label: string;
  readonly path: string;
  readonly icon: ReactNode;
  readonly flag?: keyof FeatureFlags;
}

const NAV: readonly NavDefinition[] = [
  { label: "Security Overview", path: "/", icon: <DashboardIcon /> },
  { label: "Credential Health", path: "/credential-health", icon: <VerifiedUserIcon />, flag: "credentialHealth" },
  { label: "IP Activity", path: "/ip-activity", icon: <EventNoteIcon /> },
  { label: "Vulnerability Watch", path: "/vulnerability-watch", icon: <GppMaybeIcon />, flag: "vulnWatch" },
  { label: "Alerts", path: "/alerts", icon: <NotificationsActiveIcon />, flag: "alerts" },
];

export interface NavItem {
  label: string;
  href: string;
  icon: ReactNode;
  active: boolean;
  hidden: boolean;
}

/** The top-bar items; an item behind a flag is hidden while that flag is off. */
export function buildNavItems(flags: FeatureFlags, pathname: string, vulnWatchCount = 0): NavItem[] {
  return NAV.map((item) => ({
    label: item.label,
    href: item.path,
    icon: item.flag === "vulnWatch" && vulnWatchCount > 0
      ? <CountedNavIcon icon={item.icon} label={item.label} count={vulnWatchCount} />
      : item.icon,
    active:
      pathname === item.path ||
      (item.path !== "/" && pathname.startsWith(`${item.path}/`)) ||
      (item.path === "/" && pathname === ""),
    hidden: item.flag !== undefined && !flags[item.flag],
  }));
}
